<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="用户名/用户昵称/真实姓名/电话" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <client-bind-transport-vehicle-info-group-modal v-model="clientBindTransportVehicleInfoGroupModal" :initValue="clientBindTransportVehicleInfoGroupId"></client-bind-transport-vehicle-info-group-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import ClientBindTransportVehicleInfoGroupModal from '@/view/acl/components/client-bind-transport-vehicle-info-group-modal'

export default {
  name: 'clients',
  components: {
    ClientBindTransportVehicleInfoGroupModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 客户绑定车辆分组
      clientBindTransportVehicleInfoGroupModal: false,
      clientBindTransportVehicleInfoGroupId: null,

      // 用户详细信息
      userDetailModal: false,
      userDetailId: null,

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      pageSize: 0,
      content: [],
      totalElements: 0,
      columns: [
        {
          title: 'ID',
          key: 'id',
          align: 'center',
          width: 100
        },
        {
          title: '用户名',
          key: 'name',
          align: 'center',
          width: 120
        },
        {
          title: '昵称',
          key: 'nickName',
          align: 'center',
          width: 120
        },
        {
          title: '真实姓名',
          key: 'realName',
          align: 'center',
          width: 120
        },
        {
          title: '头像',
          key: 'avatarUrl',
          align: 'center',
          width: 120,
          render: (h, params) => {
            if (params.row.avatarUrl) {
              return h('img',
                {
                  attrs: { src: params.row.avatarUrl },
                  style: { width: '45px', height: '45px' }
                })
            }
          }
        },
        {
          title: '性别',
          align: 'center',
          key: 'sex',
          width: 70,
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.sexFilter = genQueryParam('sex', 'EQ', val[0])
            } else {
              this.sexFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.sex === 1) {
              return h('div', '男')
            } else if (params.row.sex === 0) {
              return h('div', '女')
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '电话',
          key: 'mobilePhoneNum',
          align: 'center',
          width: 120
        },
        {
          title: '注册时间',
          align: 'center',
          key: 'createDate',
          width: 180,
          render: (h, params) => {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '最后登录时间',
          align: 'center',
          tooltip: 'true',
          key: 'lastLoginDatetime',
          width: 180,
          render: (h, params) => {
            if (params.row.lastLoginDatetime) {
              let d = new Date(params.row.lastLoginDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '所属分组',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'userGroupId',
          width: 180,
          render: (h, params) => {
            if (params.row.userGroup) {
              return h('div', params.row.userGroup.name)
            }
          }
        },
        {
          title: '状态',
          align: 'center',
          width: 120,
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = genQueryParam('state', 'EQ', val[0])
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            const task_status = params.row.state
            if (task_status == 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'green'
                  }
                }, '正常')
              ])
            } else if (task_status == 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'red'
                  }
                }, '禁用')
              ])
            }
          }
        },

        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          minWidth: 300,
          render: (h, params) => {
            const task_status = params.row.deleted
            if (task_status === false) {
              return h('div', [
                h('strong', {
                  style: {
                    marginRight: '5px'
                  }
                }, '禁用'),
                h('i-switch', {
                  style: {
                    marginRight: '10px'
                  },
                  props: {
                    type: 'primary',
                    value: params.row.state != 1
                  },
                  on: {
                    'on-change': (val) => {
                      let disp = ''
                      let state = 0

                      if (val) {
                        state = 1
                        disp = '<p>确认禁用该用户账号</p>'
                      } else {
                        state = 0
                        disp = '<p>确认解禁该用户账号</p>'
                      }

                      // if (params.row.state == false) {
                      this.$Modal.confirm({
                        title: '确认改变用户状态',
                        content: disp,
                        onOk: () => {
                          store.dispatch('UserServ_Disable', {
                            params: { id: params.row.id, disable: state }
                          }).then(() => {
                            this.$Message.success('修改成功')
                            this.refreshPage()
                          }).catch(err => {
                            this.$Message.error(err)
                            this.refreshPage()
                          })
                        },
                        onCancel: () => {
                          this.refreshPage()
                        }
                      })
                      // }
                    }
                  }
                }, ''
                ),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onResetPasswordBtnClick(params.row.id)
                    }
                  }
                }, '重置密码'),

                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.clientBindTransportVehicleInfoGroupModal = true
                      this.clientBindTransportVehicleInfoGroupId = params.row.id
                    }
                  }
                }, '绑定运输车辆信息分组')
              ])
            } else if (task_status === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onActiveBtnClick(params.row.id)
                    }
                  }
                }, '激活')
              ])
            }
          }// render
        }// {
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'getUserInfo',
      'ClientServ_GetPage',
      'UserServ_GetRoles',
      'RoleServ_GetAll',
      'UserServ_ResetPassword',
      'UserServ_ActiveUser',
      'UserServ_Disable'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    onResetPasswordBtnClick (userId) {
      this.$Modal.confirm({
        title: '重置密码',
        content: '<p>是否确认重置此用户密码</p>',
        onOk: () => {
          store.dispatch('UserServ_ResetPassword', { params: { userId: userId } }).then(() => {
            this.$Message.success('重置密码成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    filterChange () {
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let sortParam = null
      let queryParams = []

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.sexFilter) {
        queryParams.push(this.sexFilter)
      }
      if (this.stateFilter) {
        queryParams.push(this.stateFilter)
      }

      store.dispatch('ClientServ_GetPage', {
        params: null,
        urlparams: {
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam,
          q: queryParams
        }
      }).then(() => {
        if (store.getters.get_Client_GetPageResult) {
          this.totalElements = store.getters.get_Client_GetPageResult.totalElements
          this.content = store.getters.get_Client_GetPageResult.content
          this.pageSize = store.getters.get_Client_GetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {

  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      this.setPage(1)
    })

    window.onresize = function () {
      vueTarget.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
    }
  },
  destroyed: function () {
    window.onresize = null
  }
}
</script>

<style scoped>
</style>
